// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "all-260220-0/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"49e86a15","449":"b4f599ee","688":"2b6b0509","777":"589cce8b"}[chunkId] + ".chunk.js";
};